export const localExecutionClient = 'finl-web';
export const localExecutionSite = 'finishline';
export const localExecutionEnv = 'www';
